/**
 * ReferencesList — Shows WCAG criterion and reference links.
 *
 * Provides links to external resources and WCAG guidelines for further learning.
 */

interface ReferencesListProps {
  wcagCriterion?: string; // e.g., "3.1.1 Language of Page"
  references: string[]; // URLs or formatted strings
  className?: string;
}

export function ReferencesList({
  wcagCriterion,
  references,
  className = "",
}: ReferencesListProps) {
  if (!wcagCriterion && references.length === 0) {
    return null;
  }

  return (
    <section className={`remediation-section ${className}`}>
      <h4>References</h4>
      <div className="remediation-references">
        {wcagCriterion && (
          <div className="reference-item">
            <strong>WCAG Criterion:</strong> {wcagCriterion}
          </div>
        )}
        {references.map((ref) => (
          <div key={ref} className="reference-item">
            {ref.startsWith("http") ? (
              <a href={ref} target="_blank" rel="noopener noreferrer">
                {ref}
              </a>
            ) : (
              <span>{ref}</span>
            )}
          </div>
        ))}
      </div>
    </section>
  );
}
